import type { BackendModule } from "i18next";

// German and English stay bundled for synchronous startup and fallbacks.
// Explicit imports let Vite create one optional chunk per other language.
const loaders: Record<string, () => Promise<{ default: Record<string, unknown> }>> = {
  "en-gb": () => import("./en-gb.json"),
  pl: () => import("./pl.json"),
  it: () => import("./it.json"),
  nl: () => import("./nl.json"),
};

export const localeBackend: BackendModule = {
  type: "backend",
  init() {},
  read(language, _namespace, callback) {
    const load = loaders[language];
    if (!load) {
      callback(null, {});
      return;
    }
    void load().then(
      ({ default: translations }) => callback(null, translations),
      (error: unknown) => {
        console.warn(`Alta: Sprachdatei ${language} konnte nicht geladen werden`, error);
        callback(error instanceof Error ? error : new Error(String(error)), false);
      },
    );
  },
};